import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'

import Vue from 'vue'
import './uni.promisify.adaptor'
import uView from "uview-ui"
import store from './store/index.js'

import Tabbar from '@/components/tarbar.vue'
import navigation from '@/components/Header.vue'

Vue.config.productionTip = false


// Vue.prototype.$baseUrl = 'https://dmtest.ahapp.net/h5_api/';
// Vue.prototype.$baseUrl = 'http://facepay.huasunsolar.com/web_interface/';
// Vue.prototype.$baseUrl = 'http://218.23.218.228:8018/web_interface/'
Vue.use(uView)
Vue.component('Tabbar', Tabbar)
Vue.component('navigation', navigation)
Vue.prototype.$store = store
Vue.prototype.$jump = (url) => {
	uni.navigateTo({
		url
	})
}
Vue.prototype.$goBack = () => { uni.navigateBack() }
Vue.prototype.$onWait = new Promise((resolve) => {
  Vue.prototype.$reslove = resolve
})
App.mpType = 'app'


const app = new Vue({
  store,
  ...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
import httpMeetingApi from '@/utils/meetingHttp.js'
Vue.use(httpApi, app)
Vue.use(httpMeetingApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()